import type { SVGProps } from 'react';
const SvgBinoculars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.125 4.375C6.125 3.615 6.739 3 7.5 3h1.375c.76 0 1.375.614 1.375 1.375v.688H6.125zm-1.564 4.04a2.406 2.406 0 0 1 2.368-1.977h3.665c.571 0 1.031.46 1.031 1.03V8.5h2.75V7.469c0-.572.46-1.032 1.031-1.032h3.665c1.165 0 2.162.834 2.368 1.977l.215 1.173c.155.855.464 1.676.91 2.424l.113.189A9.3 9.3 0 0 1 24 16.973v2.87a2.41 2.41 0 0 1-2.406 2.407H16.78a2.41 2.41 0 0 1-2.406-2.406V14h-2.75v5.844a2.41 2.41 0 0 1-2.406 2.406H4.406A2.41 2.41 0 0 1 2 19.844v-2.87c0-1.685.455-3.335 1.323-4.779l.112-.189a7.2 7.2 0 0 0 .911-2.423l.215-1.173zm2.368.085c-.168 0-.31.12-.34.284l-.215 1.173a9.3 9.3 0 0 1-1.169 3.115l-.111.189a7.2 7.2 0 0 0-1.032 3.712v2.87c0 .19.155.345.344.345H9.22c.189 0 .344-.155.344-.344V8.5zm12.143 0h-2.634v11.344c0 .189.154.343.343.343h4.813a.345.345 0 0 0 .343-.343v-2.87a7.24 7.24 0 0 0-1.027-3.713l-.111-.19a9.3 9.3 0 0 1-1.173-3.114l-.215-1.173a.345.345 0 0 0-.34-.284M17.125 3H18.5c.76 0 1.375.614 1.375 1.375v.688H15.75v-.688c0-.76.614-1.375 1.375-1.375"
    />
  </svg>
);
export default SvgBinoculars;
